export const BaseURL = process.env.REACT_APP_API_URL;
export const X_API_KEY = process.env.REACT_APP_X_API_KEY;
export const CreateCustomerApiPath =
  "companies/createemployee/b1f6d5c9-3628-4269-ba7d-89183a3c0412";
